import { useState, useEffect } from 'react';
import axios from 'axios';
import { Registro, DatosAPI } from '../types';

export const useRondasData = (periodo: number | string) => {
  const [datos, setDatos] = useState<Registro[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [cliente, setCliente] = useState<string>('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('No hay token de autenticación');
        }

        // Construir la URL según si es un período o una fecha
        const url =
          typeof periodo === 'string' && periodo.includes('-')
            ? `https://control.seprovinsa.com/api.php/data?fecha=${periodo}`
            : `https://control.seprovinsa.com/api.php/data?periodo=${periodo}`;

        // console.log('Fetching data from:', url);

        const response = await axios.get<DatosAPI>(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.error) {
          throw new Error(response.data.error);
        }

        // console.log('Data received:', response.data);
        setDatos(response.data.datos || []);
        if (response.data.datos && response.data.datos.length > 0) {
          setCliente(response.data.datos[0].cliente);
        }
        setError(null);
      } catch (err) {
        // console.error('Error fetching data:', err);
        setError(err instanceof Error ? err.message : 'Error al cargar los datos');
        setDatos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [periodo]);

  return { datos, loading, error, cliente };
};
